export default function($) {
  $(document).ready(function(){
    lightbox.option({
      'alwaysShowNavOnTouchDevices': true,
      'albumLabel': "%1 / %2",
      'disableScrolling': true,
      'fadeDuration': 125,
      'imageFadeDuration': 125,
      'resizeDuration': 125,
      'wrapAround': true
    })
  });
}
